const BASE_URL = 'ai-service/api/iterations'

const iterationsRequests = {
  getIterationsRequest: ({ projectId }) => ({
    url: `${BASE_URL}/project/${projectId}`,
    method: 'get',
  }),
  getIterationStatusRequest: ({ iterationId }) => ({
    url: `${BASE_URL}/${iterationId}/status`,
    method: 'get',
  }),
  getIterationDeploymentStatusRequest: ({ iterationId }) => ({
    url: `${BASE_URL}/${iterationId}/status/deployment`,
    method: 'get',
  }),
  getPagesByIterationIdRequest: (data) => ({
    url: `${BASE_URL}/pages`,
    method: 'get',
    params: data,
  }),
  getFiltersByIterationIdRequest: (iterationId) => ({
    url: `${BASE_URL}/${iterationId}/filters`,
    method: 'get',
  }),
}

export default iterationsRequests
